import { useState, useEffect } from 'react';
import { WHATSAPP_URL } from '../data/mock';
import { X } from 'lucide-react';

export default function WhatsAppButton() {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 2500);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="fixed bottom-5 right-5 z-40 flex items-end gap-3">
      {show && !dismissed && (
        <div className="hidden sm:block relative bg-white border border-slate-200 rounded-2xl px-4 py-3 shadow-lg max-w-[240px] fade-up">
          <button
            onClick={() => setDismissed(true)}
            className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-slate-800 text-white grid place-items-center hover:bg-slate-700"
            aria-label="Close"
          >
            <X size={12} />
          </button>
          <p className="text-xs text-slate-500">Need help?</p>
          <p className="text-sm font-semibold text-slate-900 mt-0.5">
            Chat with us on WhatsApp →
          </p>
          <span className="absolute -bottom-1.5 right-6 w-3 h-3 bg-white border-r border-b border-slate-200 rotate-45" />
        </div>
      )}

      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        className="group relative w-14 h-14 rounded-full bg-brand-green hover:bg-brand-green-dark grid place-items-center shadow-xl shadow-brand-green/30 transition-transform hover:scale-105"
      >
        <span className="absolute inset-0 rounded-full bg-brand-green animate-ping opacity-40" />
        <svg viewBox="0 0 32 32" className="relative w-7 h-7 text-white" fill="currentColor">
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.052-.832-2.29-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.729.315-.688.688-1.032 1.393-1.045 2.406v.114c-.014.483.09.965.315 1.395.5 1.13 1.13 2.204 1.882 3.135 1.32 1.51 3.02 2.75 4.94 3.35.5.157 1.01.24 1.535.24.55 0 1.11-.086 1.63-.28.5-.187 1.502-.66 1.802-1.19.116-.216.174-.474.174-.732 0-.116-.043-.245-.086-.362-.13-.202-2.16-1.146-2.42-1.146zm-3.023 8.35c-1.36 0-2.665-.283-3.9-.87l-2.804.943.913-2.7c-.703-1.298-1.05-2.712-1.05-4.148 0-3.898 3.16-7.058 7.06-7.058 3.9 0 7.058 3.16 7.058 7.058 0 3.9-3.16 7.058-7.058 7.058zm0-15.615c-4.734 0-8.573 3.84-8.573 8.575 0 1.512.4 3 1.144 4.313l-1.216 3.594 3.71-1.183a8.53 8.53 0 0 0 4.077 1.036c4.734 0 8.573-3.84 8.573-8.575 0-4.735-3.84-8.575-8.575-8.575z"/>
        </svg>
      </a>
    </div>
  );
}
